import { Star, ScrollText, Database } from "lucide-react";
import { Tabs, TabsList, TabsTrigger, TabsContent } from "../components/ui/tabs";
import BackupPanel from "./BackupPanel";
import AuditLogPanel from "../components/AuditLogPanel";

/**
 * Sezione Sceriffo — pannello riservato esclusivamente al grado Sceriffo.
 * Contiene i controlli più sensibili del sistema: audit log completo e backup.
 * Sotto Sceriffo e Assistente Sceriffo NON hanno accesso a questa sezione.
 */
export default function AreaSceriffo() {
  return (
    <div className="space-y-8 max-w-7xl mx-auto" data-testid="area-sceriffo">
      <div>
        <div className="flex items-center gap-3 mb-2">
          <div className="relative">
            <div className="absolute inset-0 bg-sheriff-gold/25 blur-lg rounded-full" />
            <Star className="h-7 w-7 text-sheriff-gold relative" fill="currentColor" />
          </div>
          <div>
            <div className="uppercase-label text-sheriff-gold">Sezione Sceriffo</div>
            <h1 className="font-heading font-black text-3xl sm:text-4xl text-[#F5E6B8]">Controlli Riservati</h1>
          </div>
        </div>
        <p className="text-[#D4C480] max-w-2xl mt-2">
          Sezione accessibile esclusivamente al grado <span className="text-sheriff-gold font-semibold">Sceriffo</span>:
          audit log completo delle attività del portale e gestione backup del sistema.
        </p>
      </div>

      <Tabs defaultValue="logs" className="w-full">
        <TabsList className="bg-[#143830] border border-sheriff-gold/25 rounded-xl flex-wrap h-auto">
          <TabsTrigger value="logs" data-testid="tab-sheriff-logs" className="rounded-xl uppercase-label">
            <ScrollText className="h-4 w-4 mr-2" /> Logs
          </TabsTrigger>
          <TabsTrigger value="backup" data-testid="tab-sheriff-backup" className="rounded-xl uppercase-label">
            <Database className="h-4 w-4 mr-2" /> Backup
          </TabsTrigger>
        </TabsList>
        <TabsContent value="logs" className="mt-6">
          <AuditLogPanel />
        </TabsContent>
        <TabsContent value="backup" className="mt-6">
          <BackupPanel />
        </TabsContent>
      </Tabs>
    </div>
  );
}
